// extracted by mini-css-extract-plugin
module.exports = {"bootcamps":"Bootcamps_bootcamps__2i-MZ"};